// Footer.jsx
import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer class="footer mt-auto py-4 bg-dark text-light">
        <div class="container">
            <div class="row">
            <div class="col-md-4 mb-3">
                <h5 class="fw-bold">Kakilima</h5>
                <p class="small">
                Platform informasi dan layanan untuk UMKM & pedagang kaki lima.
                </p>
            </div>
            <div class="col-md-4 mb-3">
                <h6 class="fw-bold">Navigasi</h6>
                <ul class="list-unstyled">
                <li><a href="/" class="text-light text-decoration-none">Beranda</a></li>
                <li><a href="/about" class="text-light text-decoration-none">Tentang</a></li>
                </ul>
            </div>
            <div class="col-md-4 mb-3">
                <h6 class="fw-bold">Kontak</h6>
                <p class="small mb-1">📍 Denpasar Timur, Bali</p>
                <p class="small mb-1">✉️ <a href="mailto:info@kakilima.com" class="text-light text-decoration-none">info@kakilima.com</a></p>
                <p class="small">📞 +62 812-3456-7890</p>
            </div>
            </div>
            <div class="text-center border-top border-secondary pt-3 mt-3">
            <small class="text-muted">
                © 2025 Kakilima. Semua hak cipta dilindungi.
            </small>
            </div>
        </div>
        </footer>
  );
};

export default Footer;